import {
  GET_CAST_BEGIN,
  GET_CAST_ERROR,
  GET_CAST_SUCCESS,
  GET_CITY_BEGIN,
  GET_CITY_ERROR,
  GET_CITY_SUCCESS,
  GET_COUNTY_BEGIN,
  GET_COUNTY_ERROR,
  GET_COUNTY_SUCCESS,
  GET_FILTER_MARITIALSTATUS_BEGIN,
  GET_FILTER_MARITIALSTATUS_ERROR,
  GET_FILTER_MARITIALSTATUS_SUCCESS,
  GET_MARITIALSTATUS_BEGIN,
  GET_MARITIALSTATUS_ERROR,
  GET_MARITIALSTATUS_SUCCESS,
  GET_RELIGION_BEGIN,
  GET_RELIGION_ERROR,
  GET_RELIGION_SUCCESS,
  GET_STATE_BEGIN,
  GET_STATE_ERROR,
  GET_STATE_SUCCESS,
} from "../utils/action";

const Basic_reducer = (state, action) => {
  switch (action.type) {
    case GET_CAST_BEGIN:
      return { ...state, cast_loading: true };
    case GET_CAST_SUCCESS:
      return { ...state, cast_loading: false, cast_data: action.payload };
    case GET_CAST_ERROR:
      return { ...state, cast_loading: false };

    case GET_COUNTY_BEGIN:
      return { ...state, coutry_loading: true };
    case GET_COUNTY_SUCCESS:
      return { ...state, coutry_loading: false, country_data: action.payload };
    case GET_COUNTY_ERROR:
      return { ...state, coutry_loading: false };

    case GET_STATE_BEGIN:
      return { ...state, state_loading: true };
    case GET_STATE_SUCCESS:
      return { ...state, state_loading: false, state_data: action.payload };
    case GET_STATE_ERROR:
      return { ...state, state_loading: false };

    case GET_CITY_BEGIN:
      return { ...state, city_loading: true };
    case GET_CITY_SUCCESS:
      return { ...state, city_loading: false, city_data: action.payload };
    case GET_CITY_ERROR:
      return { ...state, city_loading: false };

    case GET_RELIGION_BEGIN:
      return { ...state, religion_loading: true };
    case GET_RELIGION_SUCCESS:
      return {
        ...state,
        religion_loading: false,
        religion_data: action.payload,
      };
    case GET_RELIGION_ERROR:
      return { ...state, religion_loading: false };

    case GET_MARITIALSTATUS_BEGIN:
      return { ...state, maritialstatus_loading: true };
    case GET_MARITIALSTATUS_SUCCESS:
      return {
        ...state,
        maritialstatus_loading: false,
        maritialstatus_data: action.payload,
      };
    case GET_MARITIALSTATUS_ERROR:
      return { ...state, maritialstatus_loading: false };

    case GET_FILTER_MARITIALSTATUS_BEGIN:
      return { ...state, filterMaritialstatus_loading: true };
    case GET_FILTER_MARITIALSTATUS_SUCCESS:
      return {
        ...state,
        filterMaritialstatus_loading: false,
        filterMaritialstatus_data: action.payload,
      };
    case GET_FILTER_MARITIALSTATUS_ERROR:
      return { ...state, filterMaritialstatus_loading: false };

    default:
      return state;
  }
};

export default Basic_reducer;
